import React, {Fragment} from 'react';

import cs from 'classnames';
import {CSSTransition} from 'react-transition-group';
import styled from 'styled-components';

import {
  ClickablePresenceContextBox,
  PresenceContextBox,
} from './PresenceContextBox';

import type {OverlayPlacementType} from 'app/general/overlays';
import type {
  ConsumableSubscribedUserData,
  ValidContextType,
} from 'app/presence/types';
import type {contentType} from 'app/utils/content-type';

type Props = {
  show?: boolean;
  className?: string;
  direction?: 'horizontal' | 'vertical';
  contexts: Array<ValidContextType>;
  contentType: contentType;
  tooltipPlacement?: OverlayPlacementType;
  users: Record<string, Array<ConsumableSubscribedUserData>>;
};

export const PresenceContextBoxes = ({
  show,
  contexts,
  contentType,
  users,
  className,
  tooltipPlacement,
  direction,
}: Props) => (
  <StyledContainerDiv className={cs(className)}>
    <div
      className={cs('d-flex', {
        'flex-column': direction === 'vertical',
      })}
    >
      {contexts.map((contextName) => {
        const contextUsers = users[contextName] || [];

        if (contextName === 'task') {
          const contextUsersReformated = {};
          contextUsers.map((contextUser) => {
            if (contextUser.additionalData != null) {
              const key =
                contextUser.additionalData.contentType +
                '.' +
                contextUser.additionalData.objectId;

              if (contextUsersReformated[key] == null) {
                contextUsersReformated[key] = [];
              }

              contextUsersReformated[key].push(contextUser);
            }
          });

          return (
            <Fragment key={contextName}>
              {Object.keys(contextUsersReformated).map((key) => (
                <CSSTransition
                  key={key}
                  timeout={250}
                  classNames="ct"
                  in={show !== false && contextUsers.length > 0}
                  unmountOnExit
                >
                  <div className="ml-2 mb-1">
                    <ClickablePresenceContextBox
                      className="d-flex"
                      contextName={contextName}
                      contentType={contentType}
                      users={contextUsersReformated[key]}
                      tooltipPlacement={tooltipPlacement}
                    />
                  </div>
                </CSSTransition>
              ))}
            </Fragment>
          );
        } else {
          return (
            <CSSTransition
              key={contextName}
              timeout={250}
              classNames="ct"
              in={show !== false && contextUsers.length > 0}
              unmountOnExit
            >
              <div className="ml-0 mb-1">
                <PresenceContextBox
                  className="d-flex"
                  contextName={contextName}
                  contentType={contentType}
                  users={contextUsers}
                  tooltipPlacement={tooltipPlacement}
                />
              </div>
            </CSSTransition>
          );
        }
      })}
    </div>
  </StyledContainerDiv>
);

const StyledContainerDiv = styled.div`
  transition: all 500ms ease-in-out;

  &.document-detail > div {
    position: fixed;
    margin-top: 12px;
    z-index: 6;
  }

  > div {
    > div {
      &.ct-enter,
      &.ct-appear,
      &.ct-exit.ct-exit-active {
        opacity: 0.01;
      }

      &.ct-exit,
      &.ct-enter.ct-enter-active,
      &.ct-appear.ct-appear-active {
        opacity: 1;
      }

      &.ct-exit-active,
      &.ct-enter-active,
      &.ct-appear-active {
        transition: all 250ms ease-out;
      }
    }
  }
`;
